import { createContext, useContext, useState } from 'react';
import { setUserSessionCookies, clearUserSessionCookies, getUserEmailFromCookie } from '../utils/cookieUtils';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem('token') || null);
  const [role, setRole] = useState(localStorage.getItem('role') || null);
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const login = (newToken, newRole, userData = null) => {
    setToken(newToken);
    setRole(newRole);
    setUser(userData);
    localStorage.setItem('token', newToken);
    localStorage.setItem('role', newRole);
    if (userData) {
      localStorage.setItem('user', JSON.stringify(userData));
      // Set user session cookies for 15 hours
      setUserSessionCookies(userData);
    }
  };

  const logout = () => {
    setToken(null);
    setRole(null);
    setUser(null);
    localStorage.clear();
    // Clear user session cookies
    clearUserSessionCookies();
  };

  return (
    <AuthContext.Provider value={{ 
      token, 
      role, 
      user, 
      login, 
      logout,
      getUserEmail: getUserEmailFromCookie 
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
